// Описания видео из ВК часто содержат оглавление по таймкодам:
//   0:00| Вступление
//   3:00| Блокада левой ножки пучка Гиса
// Из них строим «Содержание», а остальной текст остаётся вводным описанием.

const TIMECODE_RE = /^\s*((?:\d{1,2}:)?\d{1,2}:\d{2})\s*[|\-–—.)]*\s*(.+?)\s*$/;

function toSeconds(code) {
  const parts = code.split(":").map(Number);
  return parts.reduce((acc, n) => acc * 60 + n, 0);
}

export function parseDescription(text) {
  const intro = [];
  const chapters = [];
  (text || "").split(/\r?\n/).forEach(line => {
    const m = line.match(TIMECODE_RE);
    if (m && m[2].length > 1) chapters.push({ time: m[1], seconds: toSeconds(m[1]), title: m[2] });
    else if (line.trim()) intro.push(line.trim());
  });
  // одиночный «таймкод» в тексте — не оглавление
  if (chapters.length < 3) return { intro: (text || "").trim(), chapters: [] };
  return { intro: intro.join("\n\n"), chapters };
}

// Короткое описание для карточки: вводный текст, а если его нет — первые разделы оглавления
export function cardSnippet(text, max = 190) {
  const { intro, chapters } = parseDescription(text);
  const base = intro || chapters.slice(0, 3).map(c => c.title).join(" · ");
  const plain = base.replace(/[#*_`>[\]]/g, "").replace(/\s+/g, " ").trim();
  return plain.length > max ? `${plain.slice(0, max).trim()}…` : plain;
}
